import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-6 mt-12">
      <div className="container mx-auto px-4 text-center">
        <p>&copy; 2019-2026 DR Gifted Team. All rights reserved.</p>
        <p className="text-sm text-gray-400 mt-2">
          Instant digital delivery – 25% profit margin guaranteed.
        </p>
      </div>
    </footer>
  );
};

export default Footer;